module.exports = {
  isDefaultAvatar: function (avatar) {
    return !avatar || avatar.indexOf('/images/noAvatar') > -1
  },
  getAvatarInital: function (username) {
    return (username || '').charAt(0).toUpperCase()
  },
  getAvatarClass: function (userid) {
    return `avatar-variant-${userid % 10}`
  }
}
